import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import MobileViewContent from "./MobileViewContent";
import DisplayTime from "./DisplayTime";
const moment = require('moment-timezone');

function MobileViewData({ data }) {
 
 // console.log(selectedSessionAudit);
  return (
    <>
      {!Array.isArray(data) || data.length === 0 ? (
         <Card style={{ margin: "2rem" }}>
          <CardContent>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1" color="text.secondary">
                No Required data
              </Typography>
            </div>
          </CardContent>
        </Card>
      ) : (
        data.map((d) => (
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              // height: "100vh",
              marginBottom:"2rem"
            }}
            key={d.session_audit}
          >
            <Card
              style={{
                width: "21vw",
                backgroundColor: "#90ABDA",
                textAlign: "center",
                border: "1.3px solid #273693",
                 marginBottom: "0.5rem",
                padding:"0px",
                
              }}
            >
              <CardContent  style={{
                padding:"4px"
              }}>
                {/* <Typography variant="subtitle2" color="text.primary" fontWeight="550" fontSize="12px"> */}
                  {/* {d.date} {moment(d.auditStartTime).tz("Asia/Kolkata").format()} */}
                  <DisplayTime time={d.auditStartTime} date={d.date}/>
                {/* </Typography> */}

                <Typography
                  variant="subtitle1"
                  component="div"
                  fontWeight="550"
                  sx={{ fontSize: "12px", wordBreak: "break-all" }}
                >
                  {d.common_session_audit}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.primary"
                  fontWeight="550"
                  sx={{ fontSize: "12px", wordBreak: "break-all" }}
                >
                  {d.address}
                </Typography>
              </CardContent>
            </Card>
            <MobileViewContent data={d}/>
            
          </div>
        ))
      )}
    </>
  );
}

export default MobileViewData;
